import { CONFIGS_BASE_URL, makeApiUrls } from '@enuan/m3mgr-utils';

const CONFIGURATOR_COLLECTION_NAME = 'm3.gw.chat';

export const CONFIGURATOR_API_URLS = makeApiUrls(CONFIGURATOR_COLLECTION_NAME, {
	apiPath: CONFIGS_BASE_URL,
});
